export const ENVIRONMENT = import.meta.env.VITE_ENV || "";
export const PANADATA_ROOT = import.meta.env.VITE_PANADATA_ROOT || "";

export const getCsrfToken = () =>
  document.querySelector("[name='csrf-token']")?.getAttribute("content") || "";

export const getLanguage = () => {
  const path = window.location.pathname;
  const locale = path.includes("/en/") ? "en" : "es";
  return locale;
};

// Función genérica para realizar solicitudes a la API
export const apiRequest = async (
  url: string,
  method = "GET",
  body: unknown = null,
  isFormData = false,
  options?: { throwOnError?: boolean }
) => {
  const csrfToken = getCsrfToken();
  const headers = {
    "X-CSRF-Token": csrfToken,
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  const config: RequestInit = {
    method,
    headers,
    mode: "cors",
    cache: "no-cache",
    credentials: ENVIRONMENT === "development" ? "include" : "same-origin",
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${PANADATA_ROOT}${url}`, config);
    const responseData = await response.json();
    
    // If throwOnError is false, return response data and status without throwing
    if (!response.ok && options?.throwOnError !== false) {
      throw new Error(`Error en la solicitud, estado ${response.status}`);
    }
    
    // Return both data and status info when throwOnError is false
    if (options?.throwOnError === false) {
      return { data: responseData, status: response.status, ok: response.ok };
    }
    
    return responseData;
  } catch (error) {
    console.error("Error en la solicitud API:", error);
    throw error;
  }
};

// Función para enviar eventos a Mixpanel
export const sendEvent = async (payload: unknown) => {
  const csrfToken = getCsrfToken();

  await fetch(`${PANADATA_ROOT}/send_event`, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: ENVIRONMENT === "development" ? "include" : "same-origin",
    headers: {
      "X-CSRF-Token": csrfToken.toString(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ payload: payload }),
  });
};

export const getLocale = (): string => {
  const url = window.location.pathname;
  const locale = url.split("/")[1];
  return locale || "es";
};
